<template>
  <div>
    <div class="listContent">
      <div class="search-form-group">
        <el-radio-group v-model="period" size="medium" @change="periodChange">
          <el-radio-button label="0">首页设置</el-radio-button>
          <el-radio-button label="1">参数设置</el-radio-button>
          <el-radio-button label="2">报警设置</el-radio-button>
        </el-radio-group>
      </div>
      <div class="typeContent" v-show="period == 0">
        <div
          class="type"
          :class="[typeShow == 1 ? 'typeShow' : '']"
          @click="setTypeChange(1)"
        >
          <div class="imgCon imgCon_1"></div>
          <span class="typeText">现场监控首页</span>
          <div class="typeCheck" v-if="typeShow == 1"></div>
        </div>
        <!-- <div
          class="type"
          :class="[typeShow == 2 ? 'typeShow' : '']"
          @click="setTypeChange(2)"
        >
          <div class="imgCon imgCon_2"></div>
          <span class="typeText">设备版首页</span>
          <div class="typeCheck" v-if="typeShow == 2"></div>
        </div>
        <div
          class="type"
          :class="[typeShow == 3 ? 'typeShow' : '']"
          @click="setTypeChange(3)"
        >
          <div class="imgCon imgCon_3"></div>
          <span class="typeText">现场监控首页</span>
          <div class="typeCheck" v-if="typeShow == 3"></div>
        </div> -->
      </div>
      <div class="commitCon" v-show="0 == period">
        <div class="commit" @click="setContorl">确认</div>
        <span class="commitText">确认后将在下次登录后切换</span>
      </div>

      <div class="paramSettings" v-show="1 == period">
        <div class="projectSelectorInput">
          <div class="line"></div>
          <div class="lineText">选择工程</div>
          <el-select
            v-model="currentProject"
            placeholder="请选择"
            @change="projectChange"
            class="projectSelector"
          >
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </div>

        <div class="rollTimesInput">
          <div class="line"></div>
          <div class="lineText">碾压标准设置：碾压遍数</div>

          <div class="rolleTimeInput1">
            <span class="settingsTitle">欠压</span
            ><el-input
              v-model="array1[0]"
              :readonly="true"
              class="settingsInput"
            ></el-input>
            —
            <el-input
              v-model="array1[1]"
              :readonly="true"
              class="settingsInput"
            ></el-input>
          </div>

          <div class="rolleTimeInput2">
            <span class="settingsTitle">合格</span
            ><el-input
              v-model="array1[2]"
              placeholder="请输入最小合格遍数"
              :readonly="true"
              class="settingsInput"
            ></el-input>
            —
            <el-input
              v-model="array1[3]"
              :readonly="true"
              placeholder="请输入最大合格遍数"
              class="settingsInput"
            ></el-input>
          </div>

          <div class="rolleTimeInput3">
            <span class="settingsTitle">过压</span
            ><el-input
              v-model="array1[4]"
              :readonly="true"
              placeholder="请输入最小过压遍数"
              class="settingsInput"
            ></el-input>
            —
            <el-input
              v-model="array1[5]"
              :readonly="true"
              placeholder=""
              class="settingsInput"
              :disabled="true"
            ></el-input>
          </div>

          <div class="commitCon commitCon2" v-show="1 == period">
            <div class="commit" @click="openD1">修改</div>
            <span class="commitText">确认后将在下次登录后切换</span>
          </div>
        </div>
        <div class="rollTimesInput">
          <div class="line"></div>
          <div class="lineText">碾压标准设置：压实度</div>
          <div class="rolleTimeInput4">
            <span class="settingsTitle">欠压</span
            ><el-input
              v-model="array2[0]"
              :readonly="true"
              class="settingsInput"
            ></el-input>
            —
            <el-input
              v-model="array2[1]"
              :readonly="true"
              class="settingsInput"
            ></el-input>
          </div>
          <div class="rolleTimeInput2">
            <span class="settingsTitle">合格</span
            ><el-input
              v-model="array2[2]"
              :readonly="true"
              class="settingsInput"
            ></el-input>
            —
            <el-input
              v-model="array2[3]"
              :readonly="true"
              class="settingsInput"
            ></el-input>
          </div>
          <div class="rolleTimeInput3">
            <span class="settingsTitle">过压</span
            ><el-input
              v-model="array2[4]"
              :readonly="true"
              class="settingsInput"
            ></el-input>
            —
            <el-input
              v-model="array2[5]"
              :readonly="true"
              class="settingsInput"
              :disabled="true"
            ></el-input>
          </div>
          <div class="commitCon commitCon2" v-show="1 == period">
            <div class="commit" @click="openD2">修改</div>
            <span class="commitText">确认后将在下次登录后切换</span>
          </div>
        </div>
        <div class="rollColor">
          <div class="line"></div>
          <div class="lineText">碾压色阶设置：遍数</div>
          <div class="colobox">
            <div
              class="colorSpan"
              :style="'background:' + val.color"
              v-for="(val, i) in colorTimesList"
              :key="i"
            >
              {{ val.num }}遍
            </div>
          </div>
          <!-- <div
            class="rolleTimeInput55"
            v-for="(val, i) in colorTimesList"
            :key="i"
          >
            <el-input
              v-model="array1[2 * i]"
              :readonly="true"
              class="settingsInput"
            ></el-input>
            —
            <el-input
              v-model="array1[2 * i + 1]"
              :readonly="true"
              class="settingsInput"
            ></el-input>
            <div class="rollColorSpan" :style="'background:' + val.color"></div>
          </div> -->
          <div class="commitCon commitCon3" v-show="1 == period">
            <div class="commit" @click="openD3">修改</div>
            <span class="commitText">确认后将在下次登录后切换</span>
          </div>
        </div>

        <div class="rollCompactColor">
          <div class="line"></div>

          <div class="lineText">碾压色阶设置：压实度</div>

          <div
            class="rolleTimeInput55"
            v-for="(val, i) in rollIcvColorList"
            :key="i"
          >
            <el-input
              v-model="array3[2 * i]"
              :readonly="true"
              class="settingsInput"
            ></el-input>
            —
            <el-input
              v-model="array3[2 * i + 1]"
              :readonly="true"
              class="settingsInput"
            ></el-input>
            <div class="rollColorSpan" :style="'background:' + val.color"></div>
          </div>
          <div class="commitCon commitCon5" v-show="1 == period">
            <div class="commit" @click="openD4">修改</div>
            <span class="commitText">确认后将在下次登录后切换</span>
          </div>
          <div style="clear: both"></div>
        </div>
        <!-- 碾压温度 -->
        <div class="pavTempColor">
          <div class="line"></div>

          <div class="lineText">温度色阶设置：碾压温度</div>

          <div
            class="rolleTimeInput55"
            v-for="(val, i) in rollTempList"
            :key="i"
          >
            <el-input
              v-model="array9[2 * i]"
              :readonly="true"
              class="settingsInput"
            ></el-input>
            —
            <el-input
              v-model="array9[2 * i + 1]"
              :readonly="true"
              class="settingsInput"
            ></el-input>
            <div class="rollColorSpan" :style="'background:' + val.color"></div>
          </div>
          <div class="commitCon commitCon5" v-show="1 == period">
            <div class="commit" @click="openD6">修改</div>
            <span class="commitText">确认后将在下次登录后切换</span>
          </div>
          <div style="clear: both"></div>
        </div>
        <!-- 摊铺温度 -->
        <div class="pavTempColor">
          <div class="line"></div>

          <div class="lineText">温度色阶设置：摊铺温度</div>

          <div
            class="rolleTimeInput55"
            v-for="(val, i) in pavTempList"
            :key="i"
          >
            <el-input
              v-model="array7[2 * i]"
              :readonly="true"
              class="settingsInput"
            ></el-input>
            —
            <el-input
              v-model="array7[2 * i + 1]"
              :readonly="true"
              class="settingsInput"
            ></el-input>
            <div class="rollColorSpan" :style="'background:' + val.color"></div>
          </div>
          <div class="commitCon commitCon5" v-show="1 == period">
            <div class="commit" @click="openD5">修改</div>
            <span class="commitText">确认后将在下次登录后切换</span>
          </div>
          <div style="clear: both"></div>
        </div>

        <!-- 摊铺高程 -->
        <div class="pavTempColor">
          <div class="line"></div>

          <div class="lineText">色阶设置：摊铺高程</div>

          <div
            class="rolleTimeInput55"
            v-for="(val, i) in paverElevationColorList"
            :key="i"
          >
            <el-input
              v-model="array10[2 * i]"
              :readonly="true"
              class="settingsInput"
            ></el-input>
            —
            <el-input
              v-model="array10[2 * i + 1]"
              :readonly="true"
              class="settingsInput"
            ></el-input>
            <div class="rollColorSpan" :style="'background:' + val.color"></div>
          </div>
          <div class="commitCon commitCon5" v-show="1 == period">
            <div class="commit" @click="openD7">修改</div>
            <span class="commitText">确认后将在下次登录后切换</span>
          </div>
          <div style="clear: both"></div>
        </div>
        <!-- 平整度 -->
        <div class="pavTempColor">
          <div class="line"></div>

          <div class="lineText">色阶设置：平整度</div>

          <div
            class="rolleTimeInput55"
            v-for="(val, i) in evennessColorList"
            :key="i"
          >
            <el-input
              v-model="array11[2 * i]"
              :readonly="true"
              class="settingsInput"
            ></el-input>
            —
            <el-input
              v-model="array11[2 * i + 1]"
              :readonly="true"
              class="settingsInput"
            ></el-input>
            <div class="rollColorSpan" :style="'background:' + val.color"></div>
          </div>
          <div class="commitCon commitCon5" v-show="1 == period">
            <div class="commit" @click="openD8">修改</div>
            <span class="commitText">确认后将在下次登录后切换</span>
          </div>
          <div style="clear: both"></div>
        </div>
      </div>
      <div class="paramSettings" v-show="2 == period">
        <div class="projectSelectorInput">
          <div class="line"></div>
          <div class="lineText">选择工程</div>
          <el-select
            v-model="currentProject"
            placeholder="请选择"
            @change="projectChange"
            class="projectSelector"
          >
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </div>
        <div class="warnCon">
          <span class="searchInputText">报警内容</span>
          <el-input
            placeholder="请输入报警内容"
            v-model="maintaiSearch"
          ></el-input>
          <span class="searchInputText">报警类型</span>
          <el-select v-model="warnType" placeholder="请选择报警类型">
            <el-option
              v-for="item in warnTypeList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
          <span class="searchInputText">报警级别</span>
          <el-select v-model="warnLevel" placeholder="请选择报警级别">
            <el-option
              v-for="item in warnLevelList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
          <el-button type="danger" @click="doSearch('label')">查找</el-button>
          <el-button plain @click="resetWarnSearch">重置</el-button>
        </div>
        <div class="tablelistBody">
          <el-table
            :data="dataList"
            style="width: 100%"
            size="medium"
            v-loading="listLoading"
          >
            <el-table-column prop="order" label="序号" min-width="6.571741%">
              <template slot-scope="scope">
                <span>{{ scope.$index + (pageMsg.pageNo - 1) * 20 + 1 }}</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="content"
              label="报警内容"
              min-width="20.429353%"
            >
              <template slot-scope="scope">
                <span
                  :style="{
                    color:
                      scope.row.level == 2
                        ? '#E6A23C'
                        : scope.row.level == 3
                        ? '#F56C6C'
                        : '#333333',
                  }"
                  >{{ scope.row.content }}</span
                >
              </template>
            </el-table-column>
            <el-table-column
              prop="type"
              label="报警类型"
              min-width="12.429353%"
            >
              <template slot-scope="scope">
                <span class="" v-if="scope.row.type == 0">下位机报警</span>
                <span class="" v-if="scope.row.type == 1">智能终端报警</span>
                <span class="" v-if="scope.row.type == 2">平台报警</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="level"
              label="报警级别"
              min-width="8.429353%"
            >
              <template slot-scope="scope">
                <span
                  :style="{
                    color:
                      scope.row.level == 2
                        ? '#E6A23C'
                        : scope.row.level == 3
                        ? '#F56C6C'
                        : '#333333',
                  }"
                  >{{ scope.row.level }}</span
                >
              </template>
            </el-table-column>
            <el-table-column
              prop="unit"
              label="报警值单位"
              min-width="16.429353%"
            >
              <template slot-scope="scope">
                <span class="" v-if="scope.row.unit">{{ scope.row.unit }}</span>
                <span class="" v-else>-</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="upperLimit"
              label="报警值上限"
              min-width="16.429353%"
            ></el-table-column>
            <el-table-column
              prop="lowerLimit"
              label="报警值下限"
              min-width="16.429353%"
            ></el-table-column>
            <el-table-column
              prop="remark"
              label="备注"
              min-width="21.905805%"
            ></el-table-column>
            <el-table-column label="操作" min-width="21.905805%">
              <template slot-scope="scope">
                <span
                  class="lookMore"
                  v-if="scope.row.unit"
                  @click="editWarnList(scope.row)"
                  >修改</span
                >
                <span class="" v-else>-</span>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="pageblock">
          <el-pageCover
            class="pageBlock"
            :pageMsg="pageMsg"
            :page-sizes="[20]"
            :layout="layout"
            @sizeChange="pageSizeChange"
            @currentChange="currentPageChange"
          ></el-pageCover>
        </div>
      </div>
    </div>
    <el-dialog
      title="修改报警"
      :visible.sync="addModBoxVisible"
      :close-on-click-modal="false"
      width="400px"
      custom-class="editWarnCon"
      @close="closeDialog"
    >
      <div class="borderBlock borderPadding addAndEdit">
        <el-form
          :rules="rules"
          :model="modelObj"
          ref="addModForm"
          label-width="100px"
        >
          <el-form-item label="报警内容:" required prop="content">
            <el-input
              disabled
              class="shotType"
              v-model="modelObj.content"
              placeholder="请输入报警内容"
            ></el-input>
          </el-form-item>
          <el-form-item label="报警类型：" required prop="type">
            <el-select
              disabled
              v-model="modelObj.type"
              placeholder="请选择报警类型"
              class="shotType"
            >
              <el-option
                v-for="item in warnTypeList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="报警级别：" required prop="level">
            <el-input
              disabled
              class="shotType"
              v-model="modelObj.level"
              placeholder="请输入报警级别"
            ></el-input>
          </el-form-item>
          <el-form-item label="报警值单位：" required prop="unit">
            <el-input
              disabled
              class="shotType"
              v-model="modelObj.unit"
              placeholder="请输入报警值单位"
            ></el-input>
          </el-form-item>
          <el-form-item label="报警值上限：" required prop="upperLimit">
            <el-input
              class="shotType"
              v-model="modelObj.upperLimit"
              placeholder="请输入报警值上限"
            ></el-input>
          </el-form-item>
          <el-form-item label="报警值下限：" required prop="lowerLimit">
            <el-input
              class="shotType"
              v-model="modelObj.lowerLimit"
              placeholder="请输入报警值下限"
            ></el-input>
          </el-form-item>
          <el-form-item label="备注：" required prop="remark">
            <el-input
              class="shotType"
              v-model="modelObj.remark"
              placeholder="请输入备注"
            ></el-input>
          </el-form-item>
          <div style="clear: both"></div>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button
          @click="
            $refs.addModForm.resetFields();
            addModBoxVisible = false;
          "
          >取消</el-button
        >
        <el-button type="primary" @click="addModConfirm()">确定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="设置压实标准 - 遍数"
      :visible.sync="setRollingTimesVisible"
      :close-on-click-modal="false"
      @close="closeD1"
      width="500px !important"
      top="30vh"
    >
      <div>
        <el-form
          ref="changeRollingTimesForm"
          label-width="100px"
          @submit.native.prevent
        >
          <el-row>
            <el-col class="setD1C" :span="24">
              <span class="settingsTitle">设置欠压标准</span
              ><el-input
                v-model="array4[0]"
                :readonly="true"
                class="settingsInput"
              ></el-input>
              —
              <el-input
                v-model="array4[1]"
                @change="changeInput1(1)"
                type="number"
                class="settingsInput"
              ></el-input>
            </el-col>
            <el-col class="setD1C" :span="24">
              <span class="settingsTitle">设置合格标准</span
              ><el-input
                @change="changeInput1(2)"
                v-model="array4[2]"
                class="settingsInput"
                type="number"
              ></el-input>
              —
              <el-input
                @change="changeInput1(3)"
                v-model="array4[3]"
                type="number"
                class="settingsInput"
              ></el-input>
            </el-col>
            <el-col class="setD1C" :span="24">
              <span class="settingsTitle">设置过压标准</span
              ><el-input
                @change="changeInput1(4)"
                v-model="array4[4]"
                type="number"
                class="settingsInput"
              ></el-input>
              —
              <el-input
                v-model="array4[5]"
                type="number"
                class="settingsInput"
                :disabled="true"
              ></el-input>
            </el-col>
          </el-row>
          <div style="clear: both"></div>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="setRollingTimesVisible = false">取消</el-button>
        <el-button type="warning" @click="resetRollTimesColor">重置</el-button>
        <el-button type="primary" @click="SubmitD1Change">确定</el-button>
      </span>
    </el-dialog>

    <el-dialog
      title="设置压实标准 - 压实度"
      :visible.sync="setRollingCompactVisible"
      :close-on-click-modal="false"
      @close="closeD2"
      width="500px !important"
      top="30vh"
    >
      <div>
        <el-form
          ref="changeRollingCompactForm"
          label-width="100px"
          @submit.native.prevent
        >
          <el-row>
            <el-col class="setD1C" :span="24">
              <span class="settingsTitle">设置欠压标准</span
              ><el-input
                v-model="array5[0]"
                class="settingsInput"
                type="number"
                :readonly="true"
              ></el-input>
              —
              <el-input
                v-model="array5[1]"
                placeholder="请输入最大欠压遍数"
                @change="changeInput2(1)"
                type="number"
                class="settingsInput"
              ></el-input>
            </el-col>
            <el-col class="setD1C" :span="24">
              <span class="settingsTitle">设置合格标准</span
              ><el-input
                type="number"
                v-model="array5[2]"
                @change="changeInput2(2)"
                class="settingsInput"
              ></el-input>
              —
              <el-input
                type="number"
                v-model="array5[3]"
                @change="changeInput2(3)"
                class="settingsInput"
              ></el-input>
            </el-col>
            <el-col class="setD1C" :span="24">
              <span class="settingsTitle">设置过压标准</span
              ><el-input
                @change="changeInput2(4)"
                v-model="array5[4]"
                type="number"
                class="settingsInput"
              ></el-input>
              —
              <el-input
                type="number"
                v-model="array5[5]"
                :readonly="true"
                class="settingsInput"
                :disabled="true"
              ></el-input>
            </el-col>
          </el-row>
          <div style="clear: both"></div>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="setRollingCompactVisible = false">取消</el-button>
        <el-button type="warning" @click="resetD2Change">重置</el-button>
        <el-button type="primary" @click="SubmitD2Change">确定</el-button>
      </span>
    </el-dialog>

    <el-dialog
      title="设置碾压遍数色阶"
      :visible.sync="setRollColorTimesVisible"
      :close-on-click-modal="false"
      @close="closeD3"
      width="900px !important"
      top="30vh"
    >
      <div>
         <el-form
          ref="changeColorTimesForm"
          label-width="100px"
          @submit.native.prevent
        >
         <el-row class="colorTimesDialogContent">
            <div class="colobox">
              <div
                class="colorSpan"
                v-for="(val, i) in copyColorTimesList"
                @click="triggerColorDT(i)"
                :key="i"
                :style="{ background: timesColorList[i] }"
              >
                <span class="colorNumTxt">{{ i + 1 }}遍</span>
                <i
                  @click="deleteThis(i)"
                  v-show="i === copyColorTimesList.length - 1"
                  class="color_delete el-icon-circle-close"
                  title="删除"
                ></i>
                <el-color-picker
                  :id="generateTimesColorId(i)"
                  class="smallColorPicker"
                  v-model="timesColorList[i]"
                ></el-color-picker>
              </div>
            </div>
            <el-button class="addMore" @click="openAddSingleColor"
              >增加更多</el-button
            >
          <!-- </el-row>
          <el-row class="colorTimesDialogContent">
            <div
              class="rollInputD4"
              v-for="(val, i) in copyColorTimesList"
              :key="i"
            >
              <el-input
                v-model="array1[2 * i]"
                type="number"
                class="settingsInput"
              ></el-input>
              —
              <el-input
                type="number"
                v-model="array1[2 * i + 1]"
                class="settingsInput"
              ></el-input>

              <div
                class="rollColorSpan"
                @click="triggerColorDL(i)"
                :style="{ background: timesColorList[i] }"
              ></div>

              <el-color-picker
                :id="generateRcvColorId(i)"
                class="smallColorPicker"
                v-model="timesColorList[i]"
              ></el-color-picker>

              <span class="delete_text" @click="deleteThis4(i)">删除</span> 
            </div>

            <el-button
              class="addMore2"
              @click="setSinglePavTempColorVisible = true"
              >增加更多</el-button
            >-->
          </el-row> 
          <div style="clear: both"></div>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="SubmitD3Change">保存</el-button>
        <el-button type="warning" @click="resetD3">重置</el-button>
        <el-button @click="setRollColorTimesVisible = false">取消</el-button>
      </span>
    </el-dialog>

    <el-dialog
      title="设置单个数值"
      :visible.sync="setSingleColorVisible"
      :close-on-click-modal="false"
      @close="closeD3"
      width="300px !important"
      top="30vh"
    >
      <div>
        <el-form
          ref="changeColorTimesForm"
          label-width="100px"
          @submit.native.prevent
        >
          <el-row>
            <span class="settingsTitle leftWhite">颜色</span>
            <el-color-picker v-model="colorValue1"></el-color-picker>
            <p />
            <span class="settingsTitle leftWhite">遍数</span
            ><el-input
              :readonly="true"
              v-model="inputTimes1"
              type="number"
              class="settingsInput"
            ></el-input>
          </el-row>
          <div style="clear: both"></div>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="addColorTimeSpan">保存</el-button>
        <el-button @click="setSingleColorVisible = false">取消</el-button>
      </span>
    </el-dialog>
    <!-- 设置碾压压实度色阶 -->
    <el-dialog
      title="设置碾压压实度色阶"
      :visible.sync="setRollCompactColorVisible"
      :close-on-click-modal="false"
      @close="closeD4"
      width="1000px !important"
      top="15vh"
    >
      <div>
        <el-form
          ref="changeColorCompactForm"
          label-width="100px"
          @submit.native.prevent
        >
          <el-row class="rollInputContent">
            <div
              class="rollInputD4"
              v-for="(val, i) in copyRollIcvColorList"
              :key="i"
            >
              <el-input
                v-model="array6[2 * i]"
                type="number"
                class="settingsInput"
              ></el-input>
              —
              <el-input
                type="number"
                v-model="array6[2 * i + 1]"
                class="settingsInput"
              ></el-input>

              <div
                class="rollColorSpan"
                @click="triggerColorDL(i)"
                :style="{ background: rcvColorList[i] }"
              ></div>

              <el-color-picker
                :id="generateRcvColorId(i)"
                class="smallColorPicker"
                v-model="rcvColorList[i]"
              ></el-color-picker>

              <span class="delete_text" @click="deleteThis2(i)">删除</span>
            </div>

            <el-button
              class="addMore2"
              @click="setSingleCompactColorVisible = true"
              >增加更多</el-button
            >
            <el-radio v-model="radio" class="rollRadio" label="1"
              >具体值</el-radio
            >
          </el-row>
          <div class="middleLine"></div>
          <el-row class="rollInputContent rollInputContentRight">
            <div class="rollInputD4">
              <span class="settingsTitle">欠压</span>
              <el-input
                v-model="array2[0]"
                :readonly="false"
                class="settingsInput"
              ></el-input>
              —
              <el-input
                v-model="array2[1]"
                :readonly="false"
                class="settingsInput"
              ></el-input>
              <div
                class="rollColorSpan"
                :style="{ background: colorValueD1 }"
                @click="triggerColorD(1)"
              ></div>
              <el-color-picker
                id="colorPickerD1"
                class="smallColorPicker"
                v-model="colorValueD1"
              ></el-color-picker>
            </div>

            <div class="rollInputD4">
              <span class="settingsTitle">合格</span>
              <el-input
                v-model="array2[2]"
                :readonly="false"
                class="settingsInput"
              ></el-input>
              —
              <el-input
                v-model="array2[3]"
                :readonly="false"
                class="settingsInput"
              ></el-input>
              <div
                class="rollColorSpan"
                :style="{ background: colorValueD2 }"
                @click="triggerColorD(2)"
              ></div>
              <el-color-picker
                id="colorPickerD2"
                class="smallColorPicker"
                v-model="colorValueD2"
              ></el-color-picker>
            </div>

            <div class="rollInputD4">
              <span class="settingsTitle">过压</span>
              <el-input
                v-model="array2[4]"
                :readonly="false"
                class="settingsInput"
              ></el-input>
              —
              <el-input
                v-model="array2[5]"
                :readonly="false"
                class="settingsInput"
                :disabled="true"
              ></el-input>
              <div
                class="rollColorSpan"
                :style="{ background: colorValueD3 }"
                @click="triggerColorD(3)"
              ></div>
              <el-color-picker
                id="colorPickerD3"
                class="smallColorPicker"
                v-model="colorValueD3"
              ></el-color-picker>
            </div>
            <el-radio v-model="radio" class="rollRadio" label="2"
              >合格区间</el-radio
            >
          </el-row>
          <div style="clear: both"></div>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="saveRollCompactColor">保存</el-button>
        <el-button type="warning" @click="resetRollCompactColor"
          >重置</el-button
        >
        <el-button @click="setRollCompactColorVisible = false">取消</el-button>
      </span>
    </el-dialog>
    <!-- 设置碾压压实度色阶单个数值 -->
    <el-dialog
      title="设置单个数值"
      :visible.sync="setSingleCompactColorVisible"
      :close-on-click-modal="false"
      width="300px !important"
      top="30vh"
    >
      <div>
        <el-form
          ref="changeSingleColorCompactForm"
          label-width="100px"
          @submit.native.prevent
        >
          <el-row>
            <span class="settingsTitle leftWhite">颜色</span>
            <el-color-picker v-model="colorValueC2"></el-color-picker>
            <p />
            <span class="settingsTitle leftWhite">最小</span
            ><el-input v-model="minValue" class="settingsInput"></el-input>
            <p />
            <span class="settingsTitle leftWhite">最大</span
            ><el-input v-model="maxValue" class="settingsInput"></el-input>
          </el-row>
          <div style="clear: both"></div>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="addColorCompactSpan">保存</el-button>
        <el-button @click="setSingleCompactColorVisible = false"
          >取消</el-button
        >
      </span>
    </el-dialog>
    <!-- 设置摊铺温度色阶 -->
    <el-dialog
      title="设置摊铺温度色阶"
      :visible.sync="setPavTempColorVisible"
      :close-on-click-modal="false"
      @close="closeD5"
      width="500px !important"
      top="15vh"
    >
      <div>
        <el-form
          ref="changeColorCompactForm"
          label-width="100px"
          @submit.native.prevent
        >
          <el-row class="rollInputContent rollInputContentLeft">
            <div
              class="rollInputD4"
              v-for="(val, i) in copyPavTempList"
              :key="i"
            >
              <el-input
                v-model="array6[2 * i]"
                type="number"
                class="settingsInput"
              ></el-input>
              —
              <el-input
                type="number"
                v-model="array6[2 * i + 1]"
                class="settingsInput"
              ></el-input>

              <div
                class="rollColorSpan"
                @click="triggerColorDL(i)"
                :style="{ background: rcvColorList[i] }"
              ></div>

              <el-color-picker
                :id="generateRcvColorId(i)"
                class="smallColorPicker"
                v-model="rcvColorList[i]"
              ></el-color-picker>

              <span class="delete_text" @click="deleteThis3(i)">删除</span>
            </div>

            <el-button
              class="addMore2"
              @click="setSinglePavTempColorVisible = true"
              >增加更多</el-button
            >
            <!-- <el-radio v-model="radio" class="rollRadio" label="1"
              >具体值</el-radio
            > -->
          </el-row>
          <!-- <div class="middleLine"></div>
          <el-row class="rollInputContent rollInputContentRight">
            <div class="rollInputD4">
              <el-input
                v-model="array8[0]"
                :readonly="true"
                class="settingsInput"
              ></el-input>
              —
              <el-input
                v-model="array8[1]"
                :readonly="true"
                class="settingsInput"
              ></el-input>
              <div
                class="rollColorSpan"
                :style="{ background: colorValueD1 }"
                @click="triggerColorD(1)"
              ></div>
              <el-color-picker
                id="colorPickerD1"
                class="smallColorPicker"
                v-model="colorValueD1"
              ></el-color-picker>
            </div>

            <div class="rollInputD4">
              <el-input
                v-model="array8[2]"
                :readonly="true"
                class="settingsInput"
              ></el-input>
              —
              <el-input
                v-model="array8[3]"
                :readonly="true"
                class="settingsInput"
              ></el-input>
              <div
                class="rollColorSpan"
                :style="{ background: colorValueD2 }"
                @click="triggerColorD(2)"
              ></div>
              <el-color-picker
                id="colorPickerD2"
                class="smallColorPicker"
                v-model="colorValueD2"
              ></el-color-picker>
            </div>

            <div class="rollInputD4">
              <el-input
                v-model="array8[4]"
                :readonly="true"
                class="settingsInput"
              ></el-input>
              —
              <el-input
                v-model="array8[5]"
                :readonly="true"
                class="settingsInput"
              ></el-input>
              <div
                class="rollColorSpan"
                :style="{ background: colorValueD3 }"
                @click="triggerColorD(3)"
              ></div>
              <el-color-picker
                id="colorPickerD3"
                class="smallColorPicker"
                v-model="colorValueD3"
              ></el-color-picker>
            </div>
            <div class="rollInputD4">
              <el-input
                v-model="array8[6]"
                :readonly="true"
                class="settingsInput"
              ></el-input>
              —
              <el-input
                v-model="array8[7]"
                :readonly="true"
                class="settingsInput"
              ></el-input>
              <div
                class="rollColorSpan"
                :style="{ background: colorValueD4 }"
                @click="triggerColorD(3)"
              ></div>
              <el-color-picker
                id="colorPickerD3"
                class="smallColorPicker"
                v-model="colorValueD4"
              ></el-color-picker>
            </div>
            <div class="rollInputD4">
              <el-input
                v-model="array8[8]"
                :readonly="true"
                class="settingsInput"
              ></el-input>
              —
              <el-input
                v-model="array8[9]"
                :readonly="true"
                class="settingsInput"
              ></el-input>
              <div
                class="rollColorSpan"
                :style="{ background: colorValueD5 }"
                @click="triggerColorD(3)"
              ></div>
              <el-color-picker
                id="colorPickerD3"
                class="smallColorPicker"
                v-model="colorValueD5"
              ></el-color-picker>
            </div>
            <div class="rollInputD4">
              <el-input
                v-model="array8[10]"
                :readonly="true"
                class="settingsInput"
              ></el-input>
              —
              <el-input
                v-model="array8[11]"
                :readonly="true"
                class="settingsInput"
              ></el-input>
              <div
                class="rollColorSpan"
                :style="{ background: colorValueD6 }"
                @click="triggerColorD(3)"
              ></div>
              <el-color-picker
                id="colorPickerD3"
                class="smallColorPicker"
                v-model="colorValueD6"
              ></el-color-picker>
            </div>
            <el-radio v-model="radio" class="rollRadio" label="2"
              >合格区间</el-radio
            >
          </el-row>
          <div style="clear: both"></div> -->
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="savePavTempColor">保存</el-button>
        <el-button type="warning" @click="resetPavTempColor">重置</el-button>
        <el-button @click="setPavTempColorVisible = false">取消</el-button>
      </span>
    </el-dialog>
    <!-- 设置摊铺温度色阶单个数值 -->
    <el-dialog
      title="设置单个数值"
      :visible.sync="setSinglePavTempColorVisible"
      :close-on-click-modal="false"
      width="300px !important"
      top="30vh"
    >
      <div>
        <el-form
          ref="changeSingleColorCompactForm"
          label-width="100px"
          @submit.native.prevent
        >
          <el-row>
            <span class="settingsTitle leftWhite">颜色</span>
            <el-color-picker v-model="colorValueC3"></el-color-picker>
            <p />
            <span class="settingsTitle leftWhite">最小</span
            ><el-input
              v-model="minPavTempValue"
              class="settingsInput"
            ></el-input>
            <p />
            <span class="settingsTitle leftWhite">最大</span
            ><el-input
              v-model="maxPavTempValue"
              class="settingsInput"
            ></el-input>
          </el-row>
          <div style="clear: both"></div>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="addColorTempSpan">保存</el-button>
        <el-button @click="setSinglePavTempColorVisible = false"
          >取消</el-button
        >
      </span>
    </el-dialog>

    <!-- 设置碾压温度色阶 -->
    <el-dialog
      title="设置碾压温度色阶"
      :visible.sync="setRollTempColorVisible"
      :close-on-click-modal="false"
      @close="closeD6"
      width="500px !important"
      top="15vh"
    >
      <div>
        <el-form
          ref="changeColorCompactForm"
          label-width="100px"
          @submit.native.prevent
        >
          <el-row class="rollInputContent rollInputContentLeft">
            <div
              class="rollInputD4"
              v-for="(val, i) in copyPavTempList"
              :key="i"
            >
              <el-input
                v-model="array6[2 * i]"
                type="number"
                class="settingsInput"
              ></el-input>
              —
              <el-input
                type="number"
                v-model="array6[2 * i + 1]"
                class="settingsInput"
              ></el-input>

              <div
                class="rollColorSpan"
                @click="triggerColorDL(i)"
                :style="{ background: rcvColorList[i] }"
              ></div>

              <el-color-picker
                :id="generateRcvColorId(i)"
                class="smallColorPicker"
                v-model="rcvColorList[i]"
              ></el-color-picker>

              <span class="delete_text" @click="deleteThis4(i)">删除</span>
            </div>

            <el-button
              class="addMore2"
              @click="setSinglePavTempColorVisible = true"
              >增加更多</el-button
            >
          </el-row>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="saveRollTempColor">保存</el-button>
        <el-button type="warning" @click="resetRollTempColor">重置</el-button>
        <el-button @click="setRollTempColorVisible = false">取消</el-button>
      </span>
    </el-dialog>
    <!-- 设置碾压温度色阶单个数值 -->
    <el-dialog
      title="设置单个数值"
      :visible.sync="setSinglePavTempColorVisible"
      :close-on-click-modal="false"
      width="300px !important"
      top="30vh"
    >
      <div>
        <el-form
          ref="changeSingleColorCompactForm"
          label-width="100px"
          @submit.native.prevent
        >
          <el-row>
            <span class="settingsTitle leftWhite">颜色</span>
            <el-color-picker v-model="colorValueC3"></el-color-picker>
            <p />
            <span class="settingsTitle leftWhite">最小</span
            ><el-input
              v-model="minPavTempValue"
              class="settingsInput"
            ></el-input>
            <p />
            <span class="settingsTitle leftWhite">最大</span
            ><el-input
              v-model="maxPavTempValue"
              class="settingsInput"
            ></el-input>
          </el-row>
          <div style="clear: both"></div>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="addColorTempSpan">保存</el-button>
        <el-button @click="setSinglePavTempColorVisible = false"
          >取消</el-button
        >
      </span>
    </el-dialog>

    <!-- 设置摊铺高程 -->
    <el-dialog
      title="设置摊铺高程"
      :visible.sync="setpaverElevationVisible"
      :close-on-click-modal="false"
      @close="closeD7"
      width="500px !important"
      top="15vh"
    >
      <div>
        <el-form
          ref="changeColorCompactForm"
          label-width="100px"
          @submit.native.prevent
        >
          <el-row class="rollInputContent rollInputContentLeft">
            <div
              class="rollInputD4"
              v-for="(val, i) in copypaverElevationList"
              :key="i"
            >
              <el-input
                v-model="array10[2 * i]"
                type="number"
                class="settingsInput"
              ></el-input>
              —
              <el-input
                type="number"
                v-model="array10[2 * i + 1]"
                class="settingsInput"
              ></el-input>

              <div
                class="rollColorSpan"
                @click="triggerColorDL(i)"
                :style="{ background: rcvColorList[i] }"
              ></div>

              <el-color-picker
                :id="generateRcvColorId(i)"
                class="smallColorPicker"
                v-model="rcvColorList[i]"
              ></el-color-picker>

              <!-- <span class="delete_text" @click="deleteThis4(i)">删除</span> -->
            </div>

            <!-- <el-button
              class="addMore2"
              @click="setSinglePavTempColorVisible = true"
              >增加更多</el-button
            > -->
          </el-row>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="saveElevationColor">保存</el-button>
        <el-button type="warning" @click="resetElevationColor">重置</el-button>
        <el-button @click="setpaverElevationVisible = false">取消</el-button>
      </span>
    </el-dialog>

    <!-- 设置平整度 -->
    <el-dialog
      title="设置平整度"
      :visible.sync="setevennessVisible"
      :close-on-click-modal="false"
      @close="closeD8"
      width="500px !important"
      top="15vh"
    >
      <div>
        <el-form
          ref="changeColorCompactForm"
          label-width="100px"
          @submit.native.prevent
        >
          <el-row class="rollInputContent rollInputContentLeft">
            <div
              class="rollInputD4"
              v-for="(val, i) in copyevennessList"
              :key="i"
            >
              <el-input
                v-model="array11[2 * i]"
                type="number"
                class="settingsInput"
              ></el-input>
              —
              <el-input
                type="number"
                v-model="array11[2 * i + 1]"
                class="settingsInput"
              ></el-input>

              <div
                class="rollColorSpan"
                @click="triggerColorDL(i)"
                :style="{ background: rcvColorList[i] }"
              ></div>

              <el-color-picker
                :id="generateRcvColorId(i)"
                class="smallColorPicker"
                v-model="rcvColorList[i]"
              ></el-color-picker>

              <!-- <span class="delete_text" @click="deleteThis4(i)">删除</span> -->
            </div>

            <!-- <el-button
              class="addMore2"
              @click="setSinglePavTempColorVisible = true"
              >增加更多</el-button
            > -->
          </el-row>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="saveEvennessColor">保存</el-button>
        <el-button type="warning" @click="resetEvennessColor">重置</el-button>
        <el-button @click="setevennessVisible = false">取消</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  setHomeType,
  getEnginList,
  getProjectActivate,
  setValidCompactionNum,
  getProjectSetting,
  setValidCompactionIcv,
  setRollingColor,
  setCompactionColor,
  setTemperatureColor,
  getSearchWithPage,
  setSearchWithPage,
  setElevationColor,
  setEvennessColor
} from "../../utils/api";
import $ from "jquery";
import { Message } from "element-ui";
import ElPageCover from "../../components/overall/ElPageCover";
export default {
  name: "app",
  data() {
    return {
      arrowList: [
        {
          name: "高级设置",
          path: "",
        },
        {
          name: "",
          path: "",
        },
      ],
      period: 0,
      radio: "1",
      typeShow: 1,
      currentProject: "",
      options: [],
      colorTimesList: [],
      copyColorTimesList: [],
      rcvColorList: [],
      paverElevationList: [],
      evennessList:[],

      // rcvColorList : [],
      value: "",
      array1: [0, 0, 0, 0, 0, ""],
      array2: [0, 0, 0, 0, 0, ""],
      array3: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
      array7: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
      array9: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
      array4: [0, 0, 0, 0, 0, ""],
      array5: [0, 0, 0, 0, 0, ""],
      array6: [],
      array8: [0, 95, 95, 115, 115, 135, 135, 150, 150, 165, 165, 200],
      array10: [],
      array11: [],
      setRollingTimesVisible: false,
      setColorTimesVisible: false,
      setRollingCompactVisible: false,
      setSingleColorVisible: false,
      projList: [],
      setRollColorTimesVisible: false,
      colorValue1: "",
      inputTimes1: "",
      colorCompactData: {},
      copyColorCompactData: {},
      setRollCompactColorVisible: false,
      setPavTempColorVisible: false,
      setRollTempColorVisible: false,
      setpaverElevationVisible: false,
      setevennessVisible: false,
      setSinglePavTempColorVisible: false,
      setSingleCompactColorVisible: false,
      minValue: "",
      maxValue: "",
      minPavTempValue: "",
      maxPavTempValue: "",
      colorValueC2: "",
      colorValueC3: "",
      rollIcvColorList: [],
      copyRollIcvColorList: [],
      colorValueD1: "",
      colorValueD2: "",
      colorValueD3: "",
      colorValueD4: "",
      colorValueD5: "",
      colorValueD6: "",
      timesColorList: [],
      pavTempList: [
        {
          minTemperature: 10,
          maxTemperature: 80,
          color: "#BF4848",
        },
        {
          minTemperature: 80,
          maxTemperature: 120,
          color: "#45962C",
        },
        {
          minTemperature: 120,
          maxTemperature: 200,
          color: "#FFC800",
        },
      ],
      paverElevationColorList: [],
      evennessColorList: [],
      rollTempList: [],
      copyPavTempList: [],
      copypaverElevationList: [],
      copyevennessList: [],
      // 各个参数默认值
      // rollTimePre: [0, 6, 7, 14, 15, ""],
      rollTimePre: [0, 4, 5, 14, 15, ""],
      rollIvcPre: [0, 71, 72, 90, 91, ""],
      rollNumColorArr: [
        // { color: "#C8C8FF", num: 1 },
        // { num: 2, color: "#9696FF" },
        // { num: 3, color: "#6464FF" },
        // { num: 4, color: "#3232FF" },
        // { num: 5, color: "#0000FF" },
        // { num: 6, color: "#1155FF" },
        // { num: 7, color: "#21AAFF" },
        // { num: 8, color: "#32FFFF" },
        // { num: 9, color: "#19FFFF" },
        // { num: 10, color: "#00FF00" },
        // { num: 11, color: "#32FF00" },
        // { num: 12, color: "#64FF00" },
        // { num: 13, color: "#96FF00" },
        // { num: 14, color: "#C8FF00" },
        // { num: 15, color: "#FFFF00" },
        // { num: 16, color: "#FFC800" },
        // { num: 17, color: "#FF9600" },
        // { num: 18, color: "#FF6400" },
        // { num: 19, color: "#FF3200" },
        // { num: 20, color: "#FF0000" },
        { color: "#3232FF", num: 1 },
        { num: 2, color: "#3232FF" },
        { num: 3, color: "#3232FF" },
        { num: 4, color: "#3232FF" },
        { num: 5, color: "#00FF00" },
        { num: 6, color: "#00FF00" },
        { num: 7, color: "#00FF00" },
        { num: 8, color: "#00FF00" },
        { num: 9, color: "#00FF00" },
        { num: 10, color: "#00FF00" },
        { num: 11, color: "#00FF00" },
        { num: 12, color: "#00FF00" },
        { num: 13, color: "#00FF00" },
        { num: 14, color: "#00FF00" },
        { num: 15, color: "#FF0000" },
        { num: 16, color: "#FF0000" },
        { num: 17, color: "#FF0000" },
        { num: 18, color: "#FF0000" },
        { num: 19, color: "#FF0000" },
        { num: 20, color: "#FF0000" },
        // { minrollNum: 0, maxrollNum: 4, color: "#3232FF" },
        // { minrollNum: 5, maxrollNum: 14, color: "#00FF00" },
        // { minrollNum: 73, maxrollNum: 88, color: "#FF0000" },
      ],
      rollIcvColorArr: [
        // { minCompaction: 0, maxCompaction: 55, color: "rgba(0,0,255,1)" },
        // { minCompaction: 56, maxCompaction: 72, color: "rgba(50,255,255,1)" },
        // { minCompaction: 73, maxCompaction: 88, color: "rgba(0,255,0,1)" },
        // { minCompaction: 89, maxCompaction: 104, color: "rgba(255,0,0,1)" },
        // { minCompaction: 105, maxCompaction: 150, color: "rgba(255,0,255,1)" },
        { minCompaction: 0, maxCompaction: 72, color: "#3232FF" },
        { minCompaction: 73, maxCompaction: 90, color: "#00FF00" },
        { minCompaction: 91, maxCompaction: 160, color: "#FF0000" },
      ],
      rollTempColorArr: [
        { minTemperature: 0, maxTemperature: 95, color: "#3232FF" },
        { minTemperature: 96, maxTemperature: 150, color: "#00FF00" },
        // { minTemperature: 116, maxTemperature: 135, color: "#32FFFF" },
        // { minTemperature: 116, maxTemperature: 150, color: "#00FF00" },
        { minTemperature: 151, maxTemperature: 200, color: "#FF0000" },
        // { minTemperature: 166, maxTemperature: 200, color: "#FF00FF" },
      ],
      paverTempColorArr: [
        { minTemperature: 0, maxTemperature: 110, color: "#3232FF" },
        { minTemperature: 111, maxTemperature: 165, color: "#00FF00" },
        // { minTemperature: 116, maxTemperature: 135, color: "#32FFFF" },
        // { minTemperature: 116, maxTemperature: 150, color: "#00FF00" },
        { minTemperature: 166, maxTemperature: 200, color: "#FF0000" },
        // { minTemperature: 166, maxTemperature: 200, color: "#FF00FF" },
      ],
      elevationColorArr: [
        { minValue: 0, maxValue: 3, color: "#00FF00" },
        { minValue: 4, maxValue: 10, color: "#FFFF00" },
        { minValue: 11, maxValue: 100, color: "#FF0000" },
      ],
      evennessColorArr: [
        { minValue: 0, maxValue: 3, color: "#00FF00" },
        { minValue: 4, maxValue: 100, color: "#FF0000" },
      ],
      warnLevelList: [
        {
          label: "1",
          value: 1,
        },
        {
          label: "2",
          value: 2,
        },
        {
          label: "3",
          value: 3,
        },
      ],
      warnTypeList: [
        {
          label: "下位机报警",
          value: 0,
        },
        {
          label: "智能终端报警",
          value: 1,
        },
        {
          label: "平台报警",
          value: 2,
        },
      ],
      warnLevel: "",
      warnType: "",
      maintaiSearch: "",
      dataList: [],
      listLoading: false,
      pageMsg: {
        pageSize: 20,
        pageNo: 1,
        totalRecords: 0,
      },
      layout: " prev, pager, next, sizes, jumper , total",
      modelObj: {
        content: "",
        type: "",
        level: "",
        unit: "",
        upperLimit: "",
        lowerLimit: "",
        remark: "",
      },
      addModBoxVisible: false,
    };
  },
  computed: {
    rules: function () {
      return {
        content: [{ required: true, message: "必填" }],
        type: [{ required: true, message: "必填" }],
        level: [{ required: true, message: "必填" }],
        unit: [{ required: true, message: "必填" }],
        upperLimit: [{ required: true, message: "必填" }],
        lowerLimit: [{ required: true, message: "必填" }],
        remark: [{ required: true, message: "必填" }],
      };
    },
  },
  created() {},
  mounted() {
    let homeType = localStorage.getItem("homeType");
    if (homeType) {
      this.typeShow = parseInt(homeType) + 1;
    }
    this.$store.commit("setArrowList", this.arrowList);

    this.getProjectList();
  },
  methods: {
    //报警设置确认修改
    addModConfirm() {
      this.$refs["addModForm"].validate((valid) => {
        if (valid) {
          console.log(this.modelObj);
          setSearchWithPage(this.modelObj).then((res) => {
            // console.log(res)
            // this.showToast(res.data.code,res.data.message,this.actionName)
            if (res.data.code == 200) {
              this.addModBoxVisible = false;
              this.doSearch();
            }
          });
        } else {
          return false;
        }
      });
    },
    //报警设置点击修改按钮
    editWarnList(item) {
      this.addModBoxVisible = true;
      this.modelObj.projectId = this.currentProject;
      this.modelObj.alarmId = item.alarmId;
      this.modelObj.content = item.content;
      this.modelObj.type = item.type;
      this.modelObj.level = item.level;
      this.modelObj.unit = item.unit;
      this.modelObj.upperLimit = item.upperLimit;
      this.modelObj.lowerLimit = item.lowerLimit;
      this.modelObj.remark = item.remark;
    },
    //报警设置关闭弹窗
    closeDialog() {
      this.modelObj.content = "";
      this.modelObj.type = "";
      this.modelObj.level = "";
      this.modelObj.unit = "";
      this.modelObj.upperLimit = "";
      this.modelObj.lowerLimit = "";
      this.modelObj.remark = "";
      this.$refs.addModForm.resetFields();
      this.addModBoxVisible = false;
    },
    ////报警设置分页
    pageSizeChange(size) {
      this.pageMsg.pageSize = size;
      this.doSearch();
    },
    currentPageChange(index) {
      this.pageMsg.pageNo = index;
      this.doSearch(); //判断是否是搜索
    },
    //重置报警查询
    resetWarnSearch() {
      this.pageMsg.pageNo = 1;
      this.maintaiSearch = "";
      this.warnType = "";
      this.warnLevel = "";
      this.doSearch();
    },
    //报警设置查找按钮
    doSearch(label) {
      if (label) this.pageMsg.pageNo = 1;
      let params4 = {
        projectId: this.currentProject,
        content: this.maintaiSearch,
        type: this.warnType,
        level: this.warnLevel,
        pageSize: this.pageMsg.pageSize,
        pageNo: this.pageMsg.pageNo,
      };
      getSearchWithPage(params4).then((res) => {
        if (res.data.code == 200) {
          this.dataList = res.data.content.info.list;
          this.pageMsg.totalRecords = res.data.content.info.totalRecords;
        }
      });
    },
    generateRcvColorId(index) {
      return "rcvColorId" + index;
    },
    getProjectList() {
      let that = this;
      getEnginList({ pageSize: 100 }).then((res) => {
        that.projList = res.data.content.info.list;
        for (let i = 0; i < that.projList.length; i++) {
          let obj = {
            value: that.projList[i].id + "",
            label: that.projList[i].name,
          };
          that.options.push(obj);
        }

        getProjectActivate().then((res) => {
          that.currentProject = res.data.content.info.id + "";

          if (that.currentProject) {
            that.initSettings(that.currentProject);
          }
        });
      });
    },
    projectChange(value) {
      this.initSettings(value);
    },
    periodChange: function (e) {
      this.period = e;
    },
    //重置碾压遍数色阶
    resetRollTimesColor: function () {
      let array = new Array();
      Object.assign(array, this.rollTimePre);
      this.array4 = array;
    },
    setTypeChange(e) {
      this.typeShow = e;
    },
    setContorl() {
      let params = {
        homeType: this.typeShow * 1 - 1,
      };
      setHomeType(params).then((res) => {
        if (res.data.code == 200) {
          Message.success("设置成功");
          localStorage.setItem("homeType", this.typeShow);
        } else {
          Message.error("设置失败");
        }
      });
    },
    //保存压实度色阶
    saveRollCompactColor() {
      let params = null;
      if (this.radio == "1") {
        for (let i = 0; i < this.copyRollIcvColorList.length; i++) {
          this.copyRollIcvColorList[i].minCompaction = this.array6[2 * i];
          this.copyRollIcvColorList[i].maxCompaction = this.array6[2 * i + 1];
          this.copyRollIcvColorList[i].color = this.rcvColorList[i];
        }

        params = {
          compactionColorList: this.copyRollIcvColorList,
          projectId: this.currentProject + "",
        };
      } else if (this.radio == "2") {
        let newRollIcvColorList = new Array();

        for (let i = 0; i < 6; i += 2) {
          let obj = {
            minCompaction: this.array2[i],
            maxCompaction: this.array2[i + 1],
            color: this["colorValueD" + (i / 2 + 1)],
          };
          newRollIcvColorList.push(obj);
        }
        this.copyRollIcvColorList = newRollIcvColorList;
        params = {
          compactionColorList: this.copyRollIcvColorList,
          projectId: this.currentProject + "",
        };
      }

      let that = this;

      setCompactionColor(params).then((res) => {
        console.log(res);

        if (res.data.code == 200) {
          that.setRollCompactColorVisible = false;

          let array = new Array();

          Object.assign(array, this.copyRollIcvColorList);

          this.rollIcvColorList = array;

          for (let i = 0; i < that.rollIcvColorList.length; i++) {
            that.$set(
              that.array3,
              2 * i,
              that.rollIcvColorList[i].minCompaction
            );
            that.$set(
              that.array3,
              2 * i + 1,
              that.rollIcvColorList[i].maxCompaction
            );
          }
          this.$notify({
            title: "成功",
            message: "修改成功",
            type: "success",
          });
        }
      });
    },
    //保存碾压温度
    saveRollTempColor() {
      let params = null;
      if (this.radio == "1") {
        for (let i = 0; i < this.copyPavTempList.length; i++) {
          this.copyPavTempList[i].minTemperature = this.array6[2 * i];
          this.copyPavTempList[i].maxTemperature = this.array6[2 * i + 1];
          this.copyPavTempList[i].color = this.rcvColorList[i];
        }

        params = {
          temperatureColorList: this.copyPavTempList,
          projectId: this.currentProject + "",
        };
      } else if (this.radio == "2") {
        let newRollIcvColorList = new Array();

        for (let i = 0; i < 12; i += 2) {
          let obj = {
            minTemperature: this.array8[i],
            maxTemperature: this.array8[i + 1],
            color: this["colorValueD" + (i / 2 + 1)],
          };
          newRollIcvColorList.push(obj);
        }
        this.copyPavTempList = newRollIcvColorList;
        params = {
          temperatureColorList: this.copyPavTempList,
          projectId: this.currentProject + "",
        };
      }

      let that = this;

      setTemperatureColor(params).then((res) => {
        console.log(res);

        if (res.data.code == 200) {
          that.setRollTempColorVisible = false;

          let array = new Array();

          Object.assign(array, this.copyPavTempList);

          this.rollTempList = array;

          for (let i = 0; i < that.rollTempList.length; i++) {
            that.$set(that.array9, 2 * i, that.rollTempList[i].minTemperature);
            that.$set(
              that.array9,
              2 * i + 1,
              that.rollTempList[i].maxTemperature
            );
          }
          this.$notify({
            title: "成功",
            message: "修改成功",
            type: "success",
          });
        }
      });
    },
    //保存摊铺温度
    savePavTempColor() {
      let params = null;
      if (this.radio == "1") {
        for (let i = 0; i < this.copyPavTempList.length; i++) {
          this.copyPavTempList[i].minTemperature = this.array6[2 * i];
          this.copyPavTempList[i].maxTemperature = this.array6[2 * i + 1];
          this.copyPavTempList[i].color = this.rcvColorList[i];
        }

        params = {
          paverTemperatureColorList: this.copyPavTempList,
          projectId: this.currentProject + "",
        };
      } else if (this.radio == "2") {
        let newRollIcvColorList = new Array();

        for (let i = 0; i < 12; i += 2) {
          let obj = {
            minTemperature: this.array8[i],
            maxTemperature: this.array8[i + 1],
            color: this["colorValueD" + (i / 2 + 1)],
          };
          newRollIcvColorList.push(obj);
        }
        this.copyPavTempList = newRollIcvColorList;
        params = {
          paverTemperatureColorList: this.copyPavTempList,
          projectId: this.currentProject + "",
        };
      }

      let that = this;

      setTemperatureColor(params).then((res) => {
        console.log(res);

        if (res.data.code == 200) {
          that.setPavTempColorVisible = false;

          let array = new Array();

          Object.assign(array, this.copyPavTempList);

          this.pavTempList = array;

          for (let i = 0; i < that.pavTempList.length; i++) {
            that.$set(that.array7, 2 * i, that.pavTempList[i].minTemperature);
            that.$set(
              that.array7,
              2 * i + 1,
              that.pavTempList[i].maxTemperature
            );
          }
          this.$notify({
            title: "成功",
            message: "修改成功",
            type: "success",
          });
        }
      });
    },
    //保存摊铺高程
    saveElevationColor() {
      let params = null;
      for (let i = 0; i < this.copypaverElevationList.length; i++) {
        this.copypaverElevationList[i].minValue = this.array10[2 * i];
        this.copypaverElevationList[i].maxValue = this.array10[2 * i + 1];
        this.copypaverElevationList[i].color = this.rcvColorList[i];
      }

      params = {
        paverElevationColorList: this.copypaverElevationList,
        projectId: this.currentProject + "",
      };
      let that = this;
      setElevationColor(params).then((res) => {
        console.log(res);

        if (res.data.code == 200) {
          that.setpaverElevationVisible = false;

          let array = new Array();

          Object.assign(array, this.copypaverElevationList);

          this.paverElevationColorList = array;

          for (let i = 0; i < that.paverElevationColorList.length; i++) {
            that.$set(
              that.array10,
              2 * i,
              that.paverElevationColorList[i].minValue
            );
            that.$set(
              that.array10,
              2 * i + 1,
              that.paverElevationColorList[i].maxValue
            );
          }
          this.$notify({
            title: "成功",
            message: "修改成功",
            type: "success",
          });
        }
      });
    },
    //保存平整度
    saveEvennessColor() {
      let params = null;
      for (let i = 0; i < this.copyevennessList.length; i++) {
        this.copyevennessList[i].minValue = this.array11[2 * i];
        this.copyevennessList[i].maxValue = this.array11[2 * i + 1];
        this.copyevennessList[i].color = this.rcvColorList[i];
      }

      params = {
        evennessColorList: this.copyevennessList,
        projectId: this.currentProject + "",
      };
      let that = this;
      setEvennessColor(params).then((res) => {
        console.log(res);

        if (res.data.code == 200) {
          that.setevennessVisible = false;

          let array = new Array();

          Object.assign(array, this.copyevennessList);

          this.evennessColorList = array;

          for (let i = 0; i < that.evennessColorList.length; i++) {
            that.$set(
              that.array11,
              2 * i,
              that.evennessColorList[i].minValue
            );
            that.$set(
              that.array11,
              2 * i + 1,
              that.evennessColorList[i].maxValue
            );
          }
          this.$notify({
            title: "成功",
            message: "修改成功",
            type: "success",
          });
        }
      });
    },
    addColorCompactSpan() {
      let obj = {
        maxCompaction: this.maxValue,
        minCompaction: this.minValue,
        color: this.colorValueC2,
      };
      let length = this.copyRollIcvColorList.push(obj);
      this.rcvColorList.push(this.colorValueC2);
      let index = length - 1;
      this.setSingleCompactColorVisible = false;
      this.$set(this.array6, 2 * index, obj.minCompaction);
      this.$set(this.array6, 2 * index + 1, obj.maxCompaction);
    },
    addColorTempSpan() {
      let obj = {
        maxTemperature: this.maxPavTempValue,
        minTemperature: this.minPavTempValue,
        color: this.colorValueC3,
      };
      let length = this.copyPavTempList.push(obj);
      this.rcvColorList.push(this.colorValueC3);
      let index = length - 1;
      this.setSinglePavTempColorVisible = false;
      this.$set(this.array6, 2 * index, obj.minTemperature);
      this.$set(this.array6, 2 * index + 1, obj.maxTemperature);
    },
    closeD1() {
      this.setRollingTimesVisible = false;
    },
    closeD2() {
      this.setRollingCompactVisible = false;
    },
    closeD3() {
      this.setColorTimesVisible = false;
    },
    triggerColorD(index) {
      $("#colorPickerD" + index)
        .children(".el-color-picker__trigger")
        .trigger("click");
    },
    triggerColorDL(index) {
      $("#rcvColorId" + index)
        .children(".el-color-picker__trigger")
        .trigger("click");
    },
    triggerColorDT(index) {
      $("#timesColorId" + index)
        .children(".el-color-picker__trigger")
        .trigger("click");
    },
    generateTimesColorId(index) {
      return "timesColorId" + index;
    },
    //保存碾压遍数
    SubmitD1Change() {
      var param = {
        projectId: this.currentProject + "",
        minPassRollingNum: this.array4[2],
        maxPassRollingNum: this.array4[3],
      };

      setValidCompactionNum(param).then((res) => {
        console.log(res);

        //提交第一个窗口，即设置压实标准-遍数窗口
        if (res.data.code == 200) {
          this.setRollingTimesVisible = false;
          let array = new Array();
          Object.assign(array, this.array4);
          this.array1 = array;
          this.$notify({
            title: "成功",
            message: "修改成功",
            type: "success",
          });
        }
      });
    },
    //保存压实度
    SubmitD2Change() {
      var param = {
        projectId: this.currentProject + "",
        minPassIcv: this.array5[2],
        maxPassIcv: this.array5[3],
      };
      let that = this;
      setValidCompactionIcv(param).then((res) => {
        that.setRollingCompactVisible = false;

        if (res.status == 200) {
          //提交第一个窗口，即设置压实标准-遍数窗口
          that.$notify({
            title: "成功",
            message: "修改成功",
            type: "success",
          });
          var array = new Array();
          Object.assign(array, that.array5);
          that.array2 = array;
        } else {
          that.$notify.error({
            title: "错误",
            message: "修改失败",
          });
        }
      });
    },
    resetD3() {
      let array = new Array();
      Object.assign(array, this.rollNumColorArr);
      this.copyColorTimesList = array;
      Object.assign(this.timesColorList, this.copyColorTimesList);
      for (let i = 0; i < this.copyColorTimesList.length; i++) {
        this.$set(this.timesColorList, i, this.copyColorTimesList[i].color);
      }
    },
    SubmitD3Change() {
      let that = this;

      for (let i = 0; i < this.copyColorTimesList.length; i++) {
        this.copyColorTimesList[i].color = this.timesColorList[i];
      }

      var param = {
        rollingColorList: this.copyColorTimesList,
        projectId: this.currentProject + "",
      };

      //保存碾压色阶设置：遍数
      setRollingColor(param).then((res) => {
        console.log(res);
        if (res.data.code == 200) {
          that.setRollColorTimesVisible = false;
          var array = new Array();
          Object.assign(array, this.copyColorTimesList);
          this.colorTimesList = array;
          this.$notify({
            title: "成功",
            message: "修改成功",
            type: "success",
          });
        }
      });
    },
    deleteThis(i) {
      this.copyColorTimesList.splice(i, 1);
      this.timesColorList.splice(i, 1);
    },
    deleteThis2(i) {
      this.copyRollIcvColorList.splice(i, 1);
      this.rcvColorList.splice(i, 1);
    },
    deleteThis3(i) {
      this.copyPavTempList.splice(i, 1);
      this.rcvColorList.splice(i, 1);
    },
    deleteThis4(i) {
      this.copyPavTempList.splice(i, 1);
      this.rcvColorList.splice(i, 1);
    },
    addColorTimeSpan() {
      /**
       * 增加颜色色块
       */
      let color = this.colorValue1;
      let time = this.inputTimes1;
      this.setSingleColorVisible = false;
      this.copyColorTimesList.push({
        color: color,
        num: time,
      });

      this.timesColorList.push(color);
    },
    openAddSingleColor() {
      this.setSingleColorVisible = true;
      this.inputTimes1 = this.timesColorList.length + 1;
    },
    resetRollCompactColor() {
      //重置碾压压实度色阶

      let array = new Array();
      Object.assign(array, this.rollIcvColorArr);
      this.copyRollIcvColorList = array;
      for (let i = 0; i < this.copyRollIcvColorList.length; i++) {
        this.$set(
          this.array6,
          2 * i,
          this.copyRollIcvColorList[i].minCompaction
        );
        this.$set(
          this.array6,
          2 * i + 1,
          this.copyRollIcvColorList[i].maxCompaction
        );
      }
      Object.assign(this.rcvColorList, this.rollIcvColorList);
      for (let i = 0; i < this.copyRollIcvColorList.length; i++) {
        this.$set(
          this.array6,
          2 * i,
          this.copyRollIcvColorList[i].minCompaction
        );
        this.$set(
          this.array6,
          2 * i + 1,
          this.copyRollIcvColorList[i].maxCompaction
        );
        this.$set(this.rcvColorList, i, this.copyRollIcvColorList[i].color);
      }

      // this.array2 = [0, 72, 73, 88, 89, ""];
      this.array2 = [0, 72, 73, 90, 91, ""];
      this.colorValueD1 = "rgba(0,0,255,1)";
      this.colorValueD2 = "rgba(0,255,0,1)";
      this.colorValueD3 = "rgba(255,0,0,1)";
    },
    resetPavTempColor() {
      //重置摊铺温度色阶

      let array = new Array();
      Object.assign(array, this.paverTempColorArr);
      this.copyPavTempList = array;
      for (let i = 0; i < this.copyPavTempList.length; i++) {
        this.$set(this.array6, 2 * i, this.copyPavTempList[i].minTemperature);
        this.$set(
          this.array6,
          2 * i + 1,
          this.copyPavTempList[i].maxTemperature
        );
      }
      Object.assign(this.rcvColorList, this.paverTempColorArr);
      for (let i = 0; i < this.copyPavTempList.length; i++) {
        this.$set(this.array6, 2 * i, this.copyPavTempList[i].minTemperature);
        this.$set(
          this.array6,
          2 * i + 1,
          this.copyPavTempList[i].maxTemperature
        );
        this.$set(this.rcvColorList, i, this.copyPavTempList[i].color);
      }
    },
    resetRollTempColor() {
      //重置碾压温度色阶

      let array = new Array();
      Object.assign(array, this.rollTempColorArr);
      this.copyPavTempList = array;
      for (let i = 0; i < this.copyPavTempList.length; i++) {
        this.$set(this.array6, 2 * i, this.copyPavTempList[i].minTemperature);
        this.$set(
          this.array6,
          2 * i + 1,
          this.copyPavTempList[i].maxTemperature
        );
      }
      Object.assign(this.rcvColorList, this.rollTempColorArr);
      for (let i = 0; i < this.copyPavTempList.length; i++) {
        this.$set(this.array6, 2 * i, this.copyPavTempList[i].minTemperature);
        this.$set(
          this.array6,
          2 * i + 1,
          this.copyPavTempList[i].maxTemperature
        );
        this.$set(this.rcvColorList, i, this.copyPavTempList[i].color);
      }
    },
    resetEvennessColor() {
      let array = new Array();
      Object.assign(array, this.evennessColorArr);
      this.copyevennessList = array;
      for (let i = 0; i < this.copyevennessList.length; i++) {
        this.$set(this.array11, 2 * i, this.copyevennessList[i].minValue);
        this.$set(
          this.array11,
          2 * i + 1,
          this.copyevennessList[i].maxValue
        );
      }
      Object.assign(this.rcvColorList, this.evennessColorArr);
      for (let i = 0; i < this.copyevennessList.length; i++) {
        this.$set(this.array11, 2 * i, this.copyevennessList[i].minValue);
        this.$set(
          this.array11,
          2 * i + 1,
          this.copyevennessList[i].maxValue
        );
        this.$set(this.rcvColorList, i, this.copyevennessList[i].color);
      }
    },
    resetElevationColor() {
      let array = new Array();
      Object.assign(array, this.elevationColorArr);
      this.copypaverElevationList = array;
      for (let i = 0; i < this.copypaverElevationList.length; i++) {
        this.$set(this.array10, 2 * i, this.copypaverElevationList[i].minValue);
        this.$set(
          this.array10,
          2 * i + 1,
          this.copypaverElevationList[i].maxValue
        );
      }
      Object.assign(this.rcvColorList, this.elevationColorArr);
      for (let i = 0; i < this.copypaverElevationList.length; i++) {
        this.$set(this.array10, 2 * i, this.copypaverElevationList[i].minValue);
        this.$set(
          this.array10,
          2 * i + 1,
          this.copypaverElevationList[i].maxValue
        );
        this.$set(this.rcvColorList, i, this.copypaverElevationList[i].color);
      }
    },
    openD1() {
      this.setRollingTimesVisible = true;
      let array = new Array();
      Object.assign(array, this.array1);
      this.array4 = array;
    },
    openD2() {
      this.setRollingCompactVisible = true;
      let array = [];
      Object.assign(array, this.array2);
      this.array5 = array;
    },
    openD3() {
      let array = new Array();
      Object.assign(array, this.colorTimesList);
      this.copyColorTimesList = array;
      Object.assign(this.timesColorList, this.copyColorTimesList);
      for (let i = 0; i < this.copyColorTimesList.length; i++) {
        this.$set(this.timesColorList, i, this.copyColorTimesList[i].color);
        // this.$set(this.array1, 2 * i, this.copyColorTimesList[i].minrollNum);
        // this.$set(
        //   this.array1,
        //   2 * i + 1,
        //   this.copypaverElevationList[i].maxrollNum
        // );
        // this.$set(
        //   this.rcvColorList,
        //   i,
        //   this.copyColorTimesList[i].color
        // );
      }
      this.setRollColorTimesVisible = true;
    },
    openD4() {
      this.setRollCompactColorVisible = true;
      let array = new Array();
      Object.assign(array, this.rollIcvColorList);

      this.copyRollIcvColorList = array;
      Object.assign(this.rcvColorList, this.rollIcvColorList);
      for (let i = 0; i < this.copyRollIcvColorList.length; i++) {
        this.$set(
          this.array6,
          2 * i,
          this.copyRollIcvColorList[i].minCompaction
        );
        this.$set(
          this.array6,
          2 * i + 1,
          this.copyRollIcvColorList[i].maxCompaction
        );
        this.$set(this.rcvColorList, i, this.copyRollIcvColorList[i].color);
      }
    },
    closeD4() {
      this.setRollCompactColorVisible = false;
    },
    openD5() {
      this.copyPavTempList = [];
      this.setPavTempColorVisible = true;
      let array = new Array();
      Object.assign(array, this.pavTempList);

      this.copyPavTempList = array;
      Object.assign(this.rcvColorList, this.pavTempList);
      for (let i = 0; i < this.copyPavTempList.length; i++) {
        this.$set(this.array6, 2 * i, this.copyPavTempList[i].minTemperature);
        this.$set(
          this.array6,
          2 * i + 1,
          this.copyPavTempList[i].maxTemperature
        );
        this.$set(this.rcvColorList, i, this.copyPavTempList[i].color);
      }
    },
    closeD5() {
      this.setPavTempColorVisible = false;
    },
    openD6() {
      this.copyPavTempList = [];
      this.setRollTempColorVisible = true;
      let array = new Array();
      Object.assign(array, this.rollTempList);

      this.copyPavTempList = array;
      Object.assign(this.rcvColorList, this.rollTempList);
      for (let i = 0; i < this.copyPavTempList.length; i++) {
        this.$set(this.array6, 2 * i, this.copyPavTempList[i].minTemperature);
        this.$set(
          this.array6,
          2 * i + 1,
          this.copyPavTempList[i].maxTemperature
        );
        this.$set(this.rcvColorList, i, this.copyPavTempList[i].color);
      }
    },
    openD7() {
      this.copypaverElevationList = [];
      this.setpaverElevationVisible = true;
      let array = new Array();
      Object.assign(array, this.paverElevationColorList);

      this.copypaverElevationList = array;
      Object.assign(this.rcvColorList, this.paverElevationColorList);
      for (let i = 0; i < this.copypaverElevationList.length; i++) {
        this.$set(this.array10, 2 * i, this.copypaverElevationList[i].minValue);
        this.$set(
          this.array10,
          2 * i + 1,
          this.copypaverElevationList[i].maxValue
        );
        this.$set(
          this.rcvColorList,
          i,
          this.copypaverElevationList[i].color
        );
      }
    },
    openD8() {
      this.copyevennessList = [];
      this.setevennessVisible = true;
      let array = new Array();
      Object.assign(array, this.evennessColorList);

      this.copyevennessList = array;
      Object.assign(this.rcvColorList, this.evennessColorList);
      for (let i = 0; i < this.copyevennessList.length; i++) {
        this.$set(this.array11, 2 * i, this.copyevennessList[i].minValue);
        this.$set(
          this.array11,
          2 * i + 1,
          this.copyevennessList[i].maxValue
        );
        this.$set(
          this.rcvColorList,
          i,
          this.copyevennessList[i].color
        );
      }
    },
    closeD6() {
      this.setRollTempColorVisible = false;
    },
    closeD7() {
      this.setpaverElevationVisible = false;
    },
    closeD8() {
      this.setevennessVisible = false;
    },
    changeInput1(i) {
      if (i == 1) {
        let value = parseInt(this.array4[1]) + 1;
        this.$set(this.array4, 2, value);
      } else if (i == 2) {
        let value = parseInt(this.array4[2]) - 1;
        this.$set(this.array4, 1, value);
      } else if (i == 3) {
        let value = parseInt(this.array4[3]) + 1;
        this.$set(this.array4, 4, value);
      } else if (i == 4) {
        let value = parseInt(this.array4[4]) + 1;
        this.$set(this.array4, 3, value);
      }
    },
    changeInput2(i) {
      if (i == 1) {
        let value = parseInt(this.array5[1]) + 1;
        this.$set(this.array5, 2, value);
      } else if (i == 2) {
        let value = parseInt(this.array5[2]) - 1;
        this.$set(this.array5, 1, value);
      } else if (i == 3) {
        let value = parseInt(this.array5[3]) + 1;
        this.$set(this.array5, 4, value);
      } else if (i == 4) {
        let value = parseInt(this.array5[4]) + 1;
        this.$set(this.array5, 3, value);
      }
    },
    initSettings(projectId) {
      var params = {
        projectId: projectId,
      };
      let that = this;

      getProjectSetting(params).then((res) => {
        let info = res.data.content.info;
        console.log(info);
        let minPassRollingNum = info.minPassRollingNum;
        let maxPassRollingNum = info.maxPassRollingNum;
        let minPassIcv = info.minPassIcv;
        let maxPassIcv = info.maxPassIcv;

        that.$set(that.array1, 0, 0);
        that.$set(that.array1, 1, minPassRollingNum - 1);
        that.$set(that.array1, 2, minPassRollingNum);
        that.$set(that.array1, 3, maxPassRollingNum);
        that.$set(that.array1, 4, maxPassRollingNum + 1);
        // that.$set(that.array1, 5, 12);

        that.$set(that.array2, 0, 0);
        that.$set(that.array2, 1, minPassIcv - 1);
        that.$set(that.array2, 2, minPassIcv);
        that.$set(that.array2, 3, maxPassIcv);
        that.$set(that.array2, 4, maxPassIcv + 1);
        // that.$set(that.array2, 5, 100);

        that.colorTimesList = info.rollingColorList;
        that.paverElevationColorList = info.paverElevationColorList;
        that.evennessColorList = info.evennessColorList;

        that.pavTempList = info.paverTemperatureColorList || [];
        that.rollTempList = info.temperatureColorList || [];

        that.copyColorTimesList = [];

        that.rollIcvColorList = info.compactionColorList;

        if (that.rollIcvColorList == null) {
          //从store.js中的默认配置解析出
          let icvColor = this.$store.state.icvColor;
          that.rollIcvColorList = new Array();
          let icvKeys = Object.keys(icvColor);

          for (let i = 0; i < icvKeys.length - 1; i++) {
            if (i == 0) {
              //第一个
              let rollIcvObj = {
                maxCompaction: icvKeys[i],
                color: icvColor[icvKeys[i]],
                minCompaction: 0,
              };
              that.rollIcvColorList.push(rollIcvObj);
            } else {
              //其他
              let rollIcvObj = {
                maxCompaction: icvKeys[i + 1],
                color: icvColor[icvKeys[i + 1]],
                minCompaction: icvKeys[i],
              };
              that.rollIcvColorList.push(rollIcvObj);
            }
          }
        }

        if (that.colorTimesList == null) {
          let rollNumColor = this.$store.state.rollNumColor;
          that.colorTimesList = new Array();
          for (let key in rollNumColor) {
            let rollObj = {
              num: key,
              color: rollNumColor[key],
            };
            that.colorTimesList.push(rollObj);
          }
        }

        if (that.rollIcvColorList) {
          that.array6 = new Array(that.rollIcvColorList.length * 2 + 1);
          for (let i = 0; i < that.rollIcvColorList.length; i++) {
            that.$set(
              that.array3,
              2 * i,
              that.rollIcvColorList[i].minCompaction
            );
            that.$set(
              that.array3,
              2 * i + 1,
              that.rollIcvColorList[i].maxCompaction
            );
          }

          //判断是否是合格区间选项
          if (
            that.rollIcvColorList.length == 3 &&
            that.rollIcvColorList[0].minCompaction == that.array2[0] &&
            that.rollIcvColorList[0].maxCompaction == that.array2[1] &&
            that.rollIcvColorList[1].minCompaction == that.array2[2] &&
            that.rollIcvColorList[1].maxCompaction == that.array2[3] &&
            that.rollIcvColorList[2].minCompaction == that.array2[4] &&
            that.rollIcvColorList[2].maxCompaction == that.array2[5]
          ) {
            that.radio = "2";
            that.colorValueD1 = that.rollIcvColorList[0].color;
            that.colorValueD2 = that.rollIcvColorList[1].color;
            that.colorValueD3 = that.rollIcvColorList[2].color;
          }
        }

        for (let i = 0; i < that.pavTempList.length; i++) {
          that.$set(that.array7, 2 * i, that.pavTempList[i].minTemperature);
          that.$set(that.array7, 2 * i + 1, that.pavTempList[i].maxTemperature);
        }
        for (let i = 0; i < that.rollTempList.length; i++) {
          that.$set(that.array9, 2 * i, that.rollTempList[i].minTemperature);
          that.$set(
            that.array9,
            2 * i + 1,
            that.rollTempList[i].maxTemperature
          );
        }
        for (let i = 0; i < that.paverElevationColorList.length; i++) {
          that.$set(
            that.array10,
            2 * i,
            that.paverElevationColorList[i].minValue
          );
          that.$set(
            that.array10,
            2 * i + 1,
            that.paverElevationColorList[i].maxValue
          );
        }
        for (let i = 0; i < that.evennessColorList.length; i++) {
          that.$set(that.array11, 2 * i, that.evennessColorList[i].minValue);
          that.$set(
            that.array11,
            2 * i + 1,
            that.evennessColorList[i].maxValue
          );
        }
      });
      that.doSearch("label");
    },
    resetD2Change() {
      let array = [];
      Object.assign(array, this.rollIvcPre);
      this.array5 = array;
    },
  },
  components: { ElPageCover },
};
</script>
<style>
.smallColorPicker > .el-color-picker__trigger {
  display: none;
}
</style>
<style lang="scss">
.warnCon {
  .el-input {
    width: 200px !important;
    margin-right: 20px;
  }
  .el-button {
    margin-left: 20px;
  }
}
.editWarnCon {
  width: 700px !important;
  .addAndEdit {
    .el-form-item {
      width: 700px !important;
      margin-bottom: 10px !important;
    }
    .el-form-item__label {
      width: 200px !important;
      padding-left: 30px !important;
    }
    .el-form-item__content {
      .el-select {
        .el-select__tags {
          margin-left: 20px;
        }
      }
    }
    .el-form-item__error {
      padding-top: 0 !important;
    }
    .el-input {
      width: 380px !important;
      height: 36px !important;
      margin-left: 23px;
      margin-right: 23px;
      font-size: 14px !important;
      .el-input__inner {
        width: 380px !important;
        height: 36px !important;
        border-radius: 1px !important;
      }
    }
  }
}
</style>
<style lang="scss" scoped="">
.rolleTimeInput1 {
  position: relative;
  left: -50px;
  top: 50px;
}
.rolleTimeInput2 {
  width: 90%;
  position: relative;
  left: 130px;
  top: 70px;
}
.rolleTimeInput3 {
  width: 90%;
  position: relative;
  left: 130px;
  top: 90px;
}
.colorNumTxt {
  position: relative;
  bottom: 20px;
}
.settingsInput {
  height: 34px;
  line-height: 34px;
  width: 100px;
}
.settingsTitle {
  margin-right: 20px;
  color: #777777;
}
.commitCon2 {
  position: relative;
  left: 160px;
  top: 50px;
}
.commitCon3 {
  position: relative;
  left: 160px;
  top: 0px;
}
.projectSelector {
  position: relative;
  left: 20px;
  bottom: 10px;
}
.projectSelectorInput {
  margin-bottom: 15px;
  .lineText {
    margin-right: 50px;
  }
}
.rollTimesInput {
  height: 286px;
}
.rolleTimeInput4 {
  left: -35px;
  position: relative;
  top: 50px;
}
.rolleTimeInput5 {
  position: relative;
  top: 110px;
  left: 130px;
}
.rolleTimeInput6 {
  position: relative;
  top: 130px;
  left: 130px;
}
.line {
  height: 16px;
  width: 4px;
  background-color: #fa0c28;
  float: left;
}
.lineText {
  float: left;
  height: 16px;
  line-height: 16px;
  font-size: 15px;
  color: #222222;
  font-weight: bold;
  margin-left: 10px;
}
.imgShow {
  height: 950px;
  width: 100%;
  background-image: url("../../images/all/applyImg.png");
  background-size: 100% 100%;
}
.listContent {
  // height: 790px;
  width: 98.5%;
  margin: 0 auto;
  background-color: #ffffff;
  padding-top: 18px;
  .search-form-group {
    margin-left: 21px;
  }
  .typeContent {
    width: 100%;
    height: 265px;
    margin-top: 61px;
    .type {
      height: 265px;
      width: 400px;
      background-color: #d5d5d8;
      float: left;
      margin-left: 16px;
      cursor: pointer;
      position: relative;
      .imgCon {
        height: 215px;
        width: 383px;
        margin: 0 auto;
        margin-top: 6px;
      }
      .imgCon_1 {
        background-image: url("../../images/all/newType_1.png");
        background-size: 100% 100%;
      }
      .imgCon_2 {
        background-image: url("../../images/all/type_2.png");
      }
      .imgCon_3 {
        background-image: url("../../images/all/type_3.png");
      }
      .typeCheck {
        height: 31px;
        width: 31px;
        position: absolute;
        background-image: url("../../images/all/typeCheck.png");
        bottom: 43px;
        right: 8px;
      }
      .typeText {
        display: inline-block;
        height: 44px;
        width: 100%;
        line-height: 44px;
        text-align: center;
        font-size: 14px;
        color: #282828;
        margin-top: 0;
      }
    }
    .typeShow {
      background-color: #e96b5a;
      span {
        color: #ffffff !important;
      }
    }
  }
  .commitCon {
    height: 36px;
    width: 80%;
    margin-top: 75px;
    position: relative;
    .commit {
      width: 60px;
      height: 36px;
      background: #e96b5a;
      border-radius: 2px;
      position: absolute;
      font-size: 15px;
      text-align: center;
      color: #ffffff;
      line-height: 36px;
      top: 0;
      left: 21px;
      cursor: pointer;
    }
    .commitText {
      height: 14px;
      line-height: 14px;
      color: #555555;
      font-size: 14px;
      position: absolute;
      display: inline-block;
      top: 11px;
      left: 100px;
    }
  }
  .commitCon4 {
    position: relative;
    left: 8.333vw;
    top: -100px;
  }
}
.listContain {
  width: 98.5%;
  margin: 0 auto;
}
.lookMore {
  display: inline-block;
  font-size: 14px;
  color: #e24747;
  background: rgba(255, 232, 232, 1);
  border: 1px solid rgba(226, 71, 71, 1);
  border-radius: 16px;
  padding: 4px 16px;
  margin-left: 10px;
  cursor: pointer;
}
.paramSettings {
  width: 100%;
  height: auto;
  padding: 50px 30px;
  .warnCon {
    width: 100%;
    font-size: 14px;
    .searchInputText {
      margin-left: 8px;
      margin-right: 10px;
    }
  }
  .tablelistBody {
    margin-top: 15px;
  }
  .pageblock {
    width: 100%;
    height: 22px;
  }
}
.rollColor {
  width: 1100px;
  height: 231px;
  .colobox {
    width: 750px;
    height: auto;
    position: relative;
    top: 2.604vw;
    left: 120px;
    clear: both;
    .colorSpan {
      text-align: center;
      line-height: 30px;
      display: inline-block;
      height: 30px;
      width: 60px;
      background: #c8c8ff;
      margin-right: 10px;
      margin-bottom: 10px;
      color: #fff;
    }
  }
}
.rollCompactColor {
  min-height: 300px;
}
.pavTempColor {
  min-height: 450px;
  margin-top: 24px;
}
.rollColorSpan {
  text-align: center;
  line-height: 1.563vw;
  display: inline-block;
  border: 1px solid #ccc;
  height: 1.563vw;
  width: 3.125vw;
  position: relative;
  left: 20px;
  top: 10px;
}
.setD1C {
  margin-bottom: 20px;
  margin-left: 60px;
}
.colorTimesDialogContent {
  width: 750px;
  .colobox {
    width: 750px;
    height: auto;
    clear: both;
    position: relative;
    left: 80px;
    .colorSpan {
      cursor: pointer;
      text-align: center;
      line-height: 30px;
      display: inline-block;
      height: 30px;
      width: 60px;
      background: transparent;
      margin-right: 30px;
      margin-bottom: 10px;
      color: white;
      i {
        color: red;
        font-weight: bold;
      }
    }
  }
}
.addMore {
  position: relative;
  left: 80px;
  top: 20px;
}
.addMore2 {
  position: relative;
  left: 0px;
  top: 20px;
}
.rollRadio {
  position: absolute;
  bottom: 0px;
  left: calc(50% - 30px);
}
.color_delete {
  position: relative;
  left: -47px;
  bottom: 32px;
  cursor: pointer;
}
.leftWhite {
  margin-left: 50px;
}
.rollInputD4 {
  margin-top: 20px;
}
.rollInputContent {
  min-height: 400px;
  padding-left: 50px;
  display: inline-block;
  padding-bottom: 50px;
}
.delete_text {
  text-decoration: underline;
  position: relative;
  left: 40px;
  top: 0px;
  cursor: pointer;
}
.middleLine {
  height: 400px;
  width: 1px;
  display: inline-block;
  position: absolute;
  left: 50%;
  border-left: 1px solid #ccc;
}
.rolleTimeInput55 {
  float: left;
  display: block;
  width: 90%;
  margin-left: 120px;
  margin-top: 20px;
}
.commitCon5 {
  float: left;
  margin-left: 100px;
  margin-top: 30px !important;
}

.rollInputContentRight {
  position: absolute;
  right: 100px;
  top: 90px;
}
.rollInputContentLeft {
  position: relative;
  // top: -206px;
}
</style>